import { XCircleIcon } from '@heroicons/react/outline';
import { LightningBoltIcon, LockClosedIcon } from '@heroicons/react/solid';
import { Box, Button, Typography } from '@mui/material';

const CancelPolicyDialogAlertInfoView = (props: { close?: () => void; continueCancel: () => void }) => {
  /**
   * methods
   */
  const closeAction = () => {
    if (props.close) props.close();
  };

  const continueAction = () => {
    if (props.continueCancel) props.continueCancel();
  };

  return (
    <Box className="mt-4 flex flex-col items-center">
      <Box className="bg-brand-secondary/20 text-brand-secondary rounded-full p-2">
        <XCircleIcon className="h-7 w-7" />
      </Box>
      <Typography className="text-black-secondary mt-4 text-center font-black" variant="h5">
        Are you sure you want to cancel <br /> Business insurance?
      </Typography>
      <Typography className="text-black-secondary mt-4 text-center font-medium" variant="subtitle1">
        If you are taking a break from your work, you can pause your coverage <br /> for up 90 days and simply re-instate the cover at a later stage.
      </Typography>
      <Box className="my-10 flex w-full flex-col items-center rounded-lg bg-black/5 p-6">
        <Typography className="font-black" variant="h6">
          Why pause instead of cancel?
        </Typography>
        <Box className="mt-3 flex flex-row">
          <Box className="flex h-11 w-11 items-center justify-center rounded-lg bg-white">
            <LightningBoltIcon className="text-brand-secondary w-5" />
          </Box>
          <Typography className="ml-3 flex flex-1" variant="subtitle2">
            When you pause your coverage, your previous projects will still be protected if claims arise. When you cancel your insurance, you will no longer be covered.
          </Typography>
        </Box>
        <Box className="mt-3 flex flex-row">
          <Box className="flex h-11 w-11 items-center justify-center rounded-lg bg-white">
            <LockClosedIcon className="text-brand-secondary w-5" />
          </Box>
          <Typography className="ml-3 flex flex-1" variant="subtitle2">
            When you re-activate your policy, any projects falls into the active date (apart from the pausing period) is fully covered. If you cancel your policy, and purchase a new policy, your
            previous policy will no longer be covered.
          </Typography>
        </Box>
      </Box>
      <Box className="mt-6 flex w-full flex-row justify-end">
        <Button className="text-brand-primary text-lg font-bold" variant="text" onClick={continueAction}>
          Continue to cancel
        </Button>
        <Button className="ml-2 h-12 w-[174px] rounded-full text-lg font-bold" color="primary" onClick={closeAction} variant="contained">
          Pause cover
        </Button>
      </Box>
    </Box>
  );
};

export default CancelPolicyDialogAlertInfoView;
